module.exports = __webpack_public_path__ + "img/orange_010.4d39d885.png";